function initTeaserCourses() {
  const teaserMaskCType = $('.frame-type-mask_hofmann_teaser_courses');
  const teaserElms = teaserMaskCType.find('.teaser-course');

  if (teaserMaskCType.length > 0 && teaserElms.length > 0) {
    teaserElms.each((i, el) => {
      const upWrap = $(el).find('.content-top');
      const downWrap = $(el).find('.content-bottom');

      if (upWrap.length > 0 && downWrap.length > 0) {
        upWrap.css('transition', 'none');
        downWrap.css({
          'margin-bottom': `-${downWrap.height()}px`,
          transition: 'none',
        });
        setTimeout(() => {
          upWrap.css('transition', '');
          downWrap.css('transition', '');
        }, 1);
      }
    });
  }
}

const teaserMaskCType = $('.frame-type-mask_hofmann_teaser_courses');
const teaserElms = teaserMaskCType.find('.teaser-course');

if (teaserMaskCType.length > 0 && teaserElms.length > 0) {
  teaserElms.find('.modal').each((i, el) => {
    const modalOpenClass = 'modal-open';
    const teaserWrapper = $(el).parents('.teaser-course');
    el.addEventListener('show.bs.modal', event => {
      teaserWrapper.addClass(modalOpenClass);
    });
    el.addEventListener('hide.bs.modal', event => {
      teaserWrapper.removeClass(modalOpenClass);
    });
  });

  $(window).on('resize', () => {
    initTeaserCourses();
  });
}
